/** Web has no bottom tab bar. */
export const useTabBarInset = (): number => 0;
